import {
  assignWholesaler,
  callToken,
  getWholesalers,
  redirectCall,
} from "@config/urls.config";
import axios from "axios";

export const fetchWholesalers = async (token: string, ticket: unknown) => {
  try {
    const response = await axios.post(
      getWholesalers,
      { ticket },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    const data: { name: string; id: string | number; is_assign?: number }[] =
      response.data.wholesalers || [];
    const sortedData =
      data.length > 0 ? data.sort((a, b) => a.name.localeCompare(b.name)) : [];
    return { status: true, data: sortedData };
  } catch (error) {
    console.error("Error getting wholesalers", error);
    return { status: false, message: "Error getting wholesalers" };
  }
};

export const fetchAssignWholesaler = async (token: string, body: unknown) => {
  try {
    const response = await axios.post(assignWholesaler, body, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { status: true, data: response.data };
  } catch (error: unknown) {
    console.error("Error assigning wholesaler", error);
    const axiosError = error as { response?: { data?: { message?: string } } };
    return {
      status: false,
      message:
        axiosError.response?.data?.message || "Error assigning wholesaler",
    };
  }
};

export const fetchCallToken = async (token: string) => {
  try {
    const response = await axios.get(callToken, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { status: true, data: response.data.data };
  } catch (error) {
    console.error("Error fetching call token", error);
    return { status: false };
  }
};

export const fetchTransferCall = async (
  token: string,
  callSid: string,
  supplierUuid: string,
  userId: string | number,
  currentUserId?: string | number,
) => {
  try {
    const body = { callSid, supplierUuid, userId, currentUserId };
    const response = await axios.post(redirectCall, body, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { status: true, data: response.data };
  } catch (error: unknown) {
    console.error("Error transering call:", error);
    const axiosError = error as { response?: { data?: { message?: string } } };
    return {
      status: false,
      error:
        axiosError.response?.data?.message ||
        "There was an error transferring call",
    };
  }
};
